
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {challengeModule, finishedChallengesModule, finishedChallengesState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ChallengesSituationsTemplate from '@/components/Challenges/ChallengesSituationsTemplate.vue';

  @Component({
    components: {
      ChallengesSituationsTemplate,
    },
  })
  export default class ChallengeFinished extends Vue {
    @finishedChallengesModule.Getter('challenges') challenges!: ChallengeModel[];
    @finishedChallengesModule.Getter('lastPage') lastPage!: number;
    @finishedChallengesModule.Getter('currentPage') page!: number;
    @finishedChallengesModule.Getter('loading') loading!: boolean;
    @finishedChallengesModule.Getter('challengesByTag') challengesByTag!: (tag: string) => ChallengeModel[];

    get tag(): string | null {
      return this.$route.query?.tag?.toString() || null
    }

    get emptyMessage(): string {
      return !!this.tag ? this.$t('challenge.labels.no_challenges_finished_with_tag', [this.tag]).toString() : this.$t('challenge.labels.no_challenges_finished').toString()
    }

    get challengesFiltered(): ChallengeModel[] {
      if (this.tag) {
        return this.challengesByTag(this.tag)
      }
      return this.challenges
    }

    async mounted() {
      this.makeRequest(1)
    }

    async inBottom() {
      if ((this.page < this.lastPage) && !this.loading) {
        this.makeRequest(this.page + 1)
      }
    }

    private async makeRequest(page: number = 1) {
      const tag = this.$route.query?.tag?.toString();
      await finishedChallengesState.fetchAll({
        page,
        tag
      });
    }
  }

